module.exports = __webpack_public_path__ + "img/31e47a7.jpg";